import React from "react";
import { useRouteActivity } from "~/hooks/useRouteActivity";
import { TopProgressBar } from "./TopProgressBar";
import "./RoutePendingUI.css";

type RoutePendingUIProps = {
  children: React.ReactNode;
};

/**
 * Layout-level pending UI for cross-route navigation only (Option A).
 * Initial load and filter navigations use PageFallbackOutlet / table loading.
 */
export const RoutePendingUI: React.FC<RoutePendingUIProps> = ({ children }) => {
  const { showLayoutOverlay } = useRouteActivity();

  return (
    <>
      <div
        className={
          showLayoutOverlay ? "route-pending-content-dimmed" : undefined
        }
      >
        {children}
      </div>
      {showLayoutOverlay && (
        <div
          className="route-pending-overlay route-pending-overlay--fixed"
          aria-hidden
        >
          <div className="route-pending-progress">
            <TopProgressBar />
          </div>
        </div>
      )}
    </>
  );
};
